import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService } from 'src/app/features/auth/authentication/services/auth.service';
import { AuthReturnUrlService } from '../services/auth-return-url.service';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard implements CanActivate {
  constructor(
    private authService: AuthService,
    private router: Router,
    private returnUrl: AuthReturnUrlService
  ) {}
  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ):
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    try {
      const isAuthenticated = this.authService.getAuthStatus();
      if (!isAuthenticated) {
        return this.redirectToLogin(state);
      }
      return true;
    } catch {
      return this.redirectToLogin(state);
    }
  }

  /**
   * Sends the user to the login page, remembering where they were headed so
   * they land there after signing in instead of on the orders list.
   */
  private redirectToLogin(state: RouterStateSnapshot): UrlTree {
    this.returnUrl.capture(state?.url);
    return this.router.createUrlTree(['']);
  }
}
